appSocial.component('lastActive', {
    templateUrl: 'shared/components/last-active/LastActiveComponent.html',
    bindings: {
        date: '<',
        options: '=options'
    },
    controller: class LastActiveComponent {
        constructor(SocialLocaleService) {
            this.dayInSec = 60 * 60 * 24;
            this.weekInSec = this.dayInSec * 7;

            this.translation = SocialLocaleService.translation;
        }

        $onInit() {
            if (Number(this.date) <= this.dayInSec) {
                this.durationIcon = 'short';
                return;
            }

            if (Number(this.date) <= this.weekInSec) {
                this.durationIcon = 'medium';
                return;
            }

            this.durationIcon = 'long';
        }

        $onChanges(changes) {

        }
    }
})
